import { connect } from 'react-redux';
import withPropsOnChange from 'recompose/withPropsOnChange';
import { defaultProps, compose, withHandlers } from 'recompose';
import moment from 'moment-timezone';
import config from '../../../../config';
import { getActiveBarbersFilterIds } from '../selectors';
import { canLoadReport } from '../helpers';
import { activeShopDiscountSplit } from '../../../auth/selectors';

const getDates = ({ startDate, endDate, timezone }) => {
  const start = moment.tz(startDate, config.dateFormat, timezone).startOf('day');
  const end = moment.tz(endDate, config.dateFormat, timezone).endOf('day');

  return { start, end };
};

const loadDataConditionally = (shouldMapOrKeys, callback) => withPropsOnChange(
  shouldMapOrKeys,
  (props) => {
    const supportsJobExport = !!props.getCsv;

    if (!supportsJobExport || props.canLoadReport) {
      const { start, end } = getDates(props);
      callback(start.toJSON(), end.toJSON(), props);
    }

    return {};
  }
);

const loadData = loadDataConditionally(
  ['startDate', 'endDate', 'brandsFilter', 'paymentFilter', 'serviceCategories', 'payoutDiscountSplit'],
  (start, end, props) => {
    if (props.getReport) {
      props.getReport(start, end);
    }
  }
);

const mapStateToProps = (state, ownProps) => ({
  timezone: state.auth.timezone,
  startDate: state.reports.startDate,
  endDate: state.reports.endDate,
  barberFilter: ownProps.barberFilterSelector(state),
  exportReportDays: ownProps.exportReportDays || config.exportReportDays,
  canLoadReport: canLoadReport(state, ownProps.exportReportDays),
  payoutDiscountSplit: activeShopDiscountSplit(state),
});

export default compose(
  defaultProps({
    barberFilterSelector: getActiveBarbersFilterIds,
  }),
  connect(mapStateToProps),
  loadData,
  withHandlers({
    downloadCsv: props => () => {
      const { start, end } = getDates(props);
      return props.getCsv(start.toJSON(), end.toJSON(), { barberFilter: props.barberFilter });
    },
  })
);
